import {
  Home, Monitor, Building2, Palette, ShoppingBag,
  Users, Wrench, PawPrint, FolderOpen, Settings, Lamp
} from 'lucide-react';

// All categories list (untuk dropdown filter + ProjectCategories)
export const allCategories = [
  { id: 1, name: 'Relokasi / Renovasi', description: 'Proyek pemindahan dan renovasi fasilitas', icon: 'Home', color: '#f97316', gradient: 'linear-gradient(135deg, #f97316, #ea580c)', tag: 'Infrastruktur' },
  { id: 5, name: 'Building Construction', description: 'Konstruksi gedung dan bangunan komersial', icon: 'Building2', color: '#14b8a6', gradient: 'linear-gradient(135deg, #14b8a6, #0d9488)', tag: 'Konstruksi' },
  { id: 17, name: 'MEP Project', description: 'Instalasi sistem Mekanikal, Elektrikal, dan Plumbing (perpipaan)', icon: 'Settings', color: '#3b82f6', gradient: 'linear-gradient(135deg, #3b82f6, #2563eb)', tag: 'Teknikal' },
  { id: 18, name: 'Rumah Tangga', description: 'Pemeliharaan dan perbaikan fasilitas kebutuhan kantor', icon: 'Lamp', color: '#ec4899', gradient: 'linear-gradient(135deg, #ec4899, #db2777)', tag: 'Layanan' },
];

// Map icon name string → lucide component
export const iconMap = { Home, Monitor, Building2, Palette, ShoppingBag, Users, Wrench, PawPrint, FolderOpen, Settings, Lamp };
